const CLIENT_SITE_TYPES = {
  DEFAULT: 'default',
  CE_ENTRY: 'ce_entry',
};

export default CLIENT_SITE_TYPES;
